import { E as s } from "./react-error-boundary.esm-DsUx8ONQ.js";
import { c as h } from "./react-error-boundary.esm-DsUx8ONQ.js";
import i from "react";
import f from "react-dom";
function p(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
var n = {}, l;
function y() {
  if (l) return n;
  l = 1;
  var t = f;
  if (process.env.NODE_ENV === "production")
    n.createRoot = t.createRoot, n.hydrateRoot = t.hydrateRoot;
  else {
    var r = t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    n.createRoot = function(a, e) {
      r.usingClientEntryPoint = !0;
      try {
        return t.createRoot(a, e);
      } finally {
        r.usingClientEntryPoint = !1;
      }
    }, n.hydrateRoot = function(a, e, o) {
      r.usingClientEntryPoint = !0;
      try {
        return t.hydrateRoot(a, e, o);
      } finally {
        r.usingClientEntryPoint = !1;
      }
    };
  }
  return n;
}
var E = y();
const R = /* @__PURE__ */ p(E);
function C({
  rootComponent: t
}) {
  const r = /* @__PURE__ */ new Map(), a = t;
  return () => ({
    async render({ dom: e, fallback: o, ...u }) {
      let c = r.get(e);
      c || (c = R.createRoot(e), r.set(e, c)), c.render(
        /* @__PURE__ */ i.createElement(s, { FallbackComponent: o }, /* @__PURE__ */ i.createElement(
          a,
          {
            ...u
          }
        ))
      );
    },
    async destroy({ dom: e }) {
      var o;
      (o = r.get(e)) == null || o.unmount(), r.delete(e);
    }
  });
}
export {
  C as createBridgeComponent,
  h as createRemoteComponent
};
